import { Clipboard, List, Sliders } from "react-feather";
import { FaFistRaised } from "react-icons/fa";

export default [
  {
    header: "Support",
  },
  {
    id: "raise_support",
    acl: "raise_support",
    title: "Raise Support",
    icon: <FaFistRaised size={20} />,
    children: [
      {
        id: "tickets",
        acl: "tickets",
        title: "Reclamations",
        icon: <Clipboard />,
        navLink: "/admin/reclamations/listReclamations",
      },
      {
        id: "ideas",
        acl: "ideas",
        title: "Ideas",
        icon: <Clipboard />,
        navLink: "/admin/ideas/listIdeas",
      },
    ],
  },
  {
    id: "support_test",
    acl: "support_test",
    title: "Support Assistance",
    icon: <Sliders size={20} />,
    navLink: "/admin/support_assistance/live",
    public: true,
  },
];
